import { Container, Sprite, TextStyle, Texture, IDestroyOptions, Rectangle } from "pixi.js";
import { TextWithUnderline } from "../../../../game/components/TextWithUnderline";
import { GameFont } from "../../../../common/GameFont";
import { Redirector } from "by/gamefactory/tools/Redirector";

export class SocialContainer extends Container {
    private icon: Sprite;
    private text: TextWithUnderline;
    private redirectUrl: string;

    public constructor(
        texture: Texture,
        text: string,
        redirectUrl: string
    ) {
        super();
        this.redirectUrl = redirectUrl;
        this.socialClickHandle = this.socialClickHandle.bind(this);

        this.icon = new Sprite(texture);
        this.icon.eventMode = "static";
        this.icon.on("pointerup", this.socialClickHandle);
        this.addChild(this.icon);
        this.text = new TextWithUnderline(text, new SocialContainerTextTextStyle(), 0, -3);
        this.text.position.set(this.width * 0.5 - this.text.width * 0.5, 170);
        this.text.eventMode = "static";
        this.text.hitArea = new Rectangle(-this.text.width * 0.5, -this.text.height * 0.5, this.text.width * 2, this.text.height * 2);
        this.text.on("pointerup", this.socialClickHandle);
        this.addChild(this.text);
    }

    private socialClickHandle(): void {
        this.eventMode = "none";
        Redirector.openPageInNewTab(this.redirectUrl);
        this.eventMode = "static";
    }

    public destroy(options?: boolean | IDestroyOptions): void {
        this.icon.off("pointerup", this.socialClickHandle);
        this.text.off("pointerup", this.socialClickHandle);
        super.destroy(options);
    }
}

class SocialContainerTextTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#FFFFFF",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            stroke: 2
        }));
    }
}
